<template>
  <v-menu
    v-model="isOpen"
    content-class="elevation-0"
    offset-y
  >
    <template v-slot:activator="{ on, attrs, value }">
      <v-btn
        :class="isAction ? ' no-radius' : 'btn-secondaire' "
        :color="isAction ? 'primary' : 'branche' "
        :disabled="isDisabled"
        elevation="0"
        rounded
        v-bind="attrs"
        v-on="on"
      >
        <span
          :class="isAction ? 'white--text' : '--text-branche' "
          class="action text-truncate "
        >{{ libelleBtn }}</span>
        <v-icon
          :class="isAction ? '' : '--text-branche' "
        >
          {{ value ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </v-btn>
    </template>
    <v-card
      class="mt-2"
      elevation="2"
    >
      <v-list
        v-for="(item, index) in items"
        :key="item.libelle"
        class="no-padding"
      >
        <v-list-item>
          <AgrButton
            elevation="0"
            plain
            @click="onClick(item.code)"
          >
            <span
              class="action black--text"
            >
              {{ item.libelle }}
            </span>
          </AgrButton>
        </v-list-item>
        <v-divider
          v-if="items.length > index + 1"
        />
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import {AgrButton} from '@agrial/ui'

export default {
  name: 'BaseSelect',
  components: { AgrButton },
  props: {
    libelleBtn: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      required: true
    },
    isAction: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
  },

  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    onClick (param) {
      this.$emit('onClick', param)
    },
  }
}
</script>

<style lang="scss" scoped>

.no-padding{
  padding: 0;
}

.no-radius {
  border-radius: 0 !important;
}

.v-list-item:hover {
  background-color: #e0e0e0 !important;
}
</style>

